"use client";
import React, { useRef, useState } from "react";
import { useRouter } from "next/navigation";

function CustomWindow({
  iframeUrl,
  setIsIframeVisible,
  isIframeVisible,
  setSelectedGame,
}) {
  const iframeContainerRef = useRef();
  const router = useRouter();
  const [isFullScreen, setIsFullScreen] = useState(false);
  const closeIframe = () => {
    setIsIframeVisible(false);
    setSelectedGame(null);
    Tawk_API.showWidget();
    document.body.style.overflow = "auto";
    router.push("/");
    // router.back();
  };

  const toggleFullScreen = () => {
    const container = iframeContainerRef.current;

    if (container) {
      if (isFullScreen) {
        // EXIT FULL SCREEN
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        setIsFullScreen(false);
      } else {
        // ENTER FULL SCREEN
        if (container.requestFullscreen) {
          container.requestFullscreen().catch((err) => {
            console.error("Error attempting to enable full-screen mode:", err);
          });
        } else if (container.webkitRequestFullscreen) {
          container.webkitRequestFullscreen();
        } else if (container.mozRequestFullScreen) {
          container.mozRequestFullScreen();
        } else if (container.msRequestFullscreen) {
          container.msRequestFullscreen();
        }
        setIsFullScreen(true);
      }
    }
  };

  return (
    <div
      id="MainContModal"
      className={`NoSelect ${isIframeVisible ? "" : "Close"}`}
    >
      <div id="ContModal" style={{ maxWidth: 1200 }} className="CustomWindow">
        <div
          className={`${isIframeVisible ? "open" : "close"}`}
          style={{ width: "100%", height: "100vh" }}
          ref={iframeContainerRef}
        >
          <div className="BarWindowNav">
            <button
              onClick={closeIframe}
              className="BtnCloseWindow"
              aria-label="CloseIframe"
            ></button>
            <button
              onClick={toggleFullScreen}
              className={`BtnFullScreen ${isFullScreen ? "ModeCF" : ""}`}
              aria-label="toggleFullScreen"
            ></button>
          </div>
          <iframe
            key={1}
            src={iframeUrl}
            title="Content of iframe"
            width="100%"
            height={"100vh"}
            allowFullScreen
            scrolling={iframeUrl?.includes("activeTab") ? "yes" : "no"}
          />
        </div>
      </div>
    </div>
  );
}

export default CustomWindow;
